import React from "react";
import "./confront.scss";

//Imagens:
import bannerMobile from "../../../../assets/homeImgs/confront-mobile.png";
import confrontDesk from "../../../../assets/homeImgs/confrontDesk.svg";
import { useTranslation } from "react-i18next";

const Confront = () => {
  let width = window.innerWidth;

  const {t} =  useTranslation()

  return (
    <div className="container-confront">
      <div data-aos="fade-right" className="texts-confront">
        <h1>{t("home.confront.title")}</h1>
        <h1>{t("home.confront.title_2")}</h1>
        <p>{t("home.confront.section_text_1")}</p>
        <a href="/form"><button id="btn-confront">{t("buttons.demo_btn_text")}</button></a>
        <p id="p-avaliation">
          {t("home.confront.section_text_2")}
        </p>
      </div>
      <div className="img-confront">
        {width >= 978
          ? <img src={confrontDesk} alt="banner desk" />
          : <img src={bannerMobile} alt=" banner mobile" />}
      </div>
    </div>
  );
};
export default Confront;
